import DefaultModal from '@/components/modal';
import OrderStatusShow from '@/components/orderStatusShow';
import Pager from '@/components/pager';
import TmsDatepicker from '@/components/tmsDatepicker';
import UnisDefaultOptionOutline from '@/components/unisDefaultOptionOutline';
import UinsDefaultSelect from '@/components/unisDefaultSelect';
import UnisProductModal from '@/components/unisProductModal';
import tmsService from '@/services/axios/tmsService';
import tmsServiceBackend from '@/services/axios/tmsServiceBackend';
import tmsServiceBlob from '@/services/axios/tmsServiceBlob';
import tmsTransformRequestService from '@/services/axios/tmsTransformRequestService';
import { LocalStorageCache } from '@/services/cache';
import { TMSCustomerAccountService } from '@/services/user';
import { analytics } from '@/services/analytics';
import util from '@/shared/util';
import {
    Button as ElButton,
    DatePicker as ElDatePicker,
    Dialog as ElDialog,
    Dropdown as ElDropdown,
    DropdownItem as ElDropdownItem,
    DropdownMenu as ElDropdownMenu,
    Form as ElForm,
    FormItem as ElFormItem,
    Input as ElInput,
    Option as ElOption,
    Select as ElSelect,
    Table as ElTable,
    TableColumn as ElTableColumn,
    Tooltip as ElTooltip,
    Message,
} from 'element-ui';
import { cloneDeep, forEach, isArray } from 'lodash-es';
import qs from 'qs';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { Component, Vue, Watch } from 'vue-property-decorator';
import TrackingGuest from '../../../trackingGuest';
import Actions from './components/actions';
import Pagination from './components/pagination';
import template from './tmpl.vue';
import * as XLSX from 'xlsx';
import {
    calcTotalWeight,
    countPallets,
    deleteOrderLine,
    getShipmentPO,
    isDisabledReadyDate,
    isEmptyAdjustedOrderLine,
    IShipment,
    preprocess,
    updatePickupReadyNPickupClose,
    updateReadyDate,
    updateReference,
    updateShipment,
    validatePalletCounts,
    validatePickupTimes,
    updateOrder,
} from './types';
import CustomizeFieldsPanel from '../CustomizeFieldsPanel/index.vue';

// 设置dayjs插件
dayjs.extend(utc);
dayjs.extend(timezone);

interface IAdjustedOrderLineDto {
    id: number;
    pallet: number;
    po: string;
    stackable: number;
    weight: number;
}

async function getCustomerAccount() {
    const customerAccountService = TMSCustomerAccountService.create({
        cache: LocalStorageCache.create(),
        tmsService: tmsService,
        tmsTransformRequestService: tmsTransformRequestService,
    });
    const res = await customerAccountService.fetchThenCacheCustomerAccount({
        request_from: 'clientV2',
        shipper_portal: 1,
    });
    const billing_list = res.billing_list || [];
    return billing_list;
}

interface IFilterTable {
    filter: string;
    or: string;
    value: string | string[] | Date[];
}

@Component({
    components: {
        DefaultModal,
        Actions,
        Pagination,
        Pager,
        UinsDefaultSelect,
        UnisProductModal,
        TmsDatepicker,
        UnisDefaultOptionOutline,
        OrderStatusShow,
        TrackingGuest,
        ElButton,
        ElDatePicker,
        ElDropdown,
        ElDropdownMenu,
        ElDropdownItem,
        ElDialog,
        ElForm,
        ElFormItem,
        ElInput,
        ElOption,
        ElSelect,
        ElTable,
        ElTableColumn,
        ElTooltip,
        'el-select': ElSelect,
        'el-option': ElOption,
        CustomizeFieldsPanel
    },
    mixins: [template],
})
class C extends Vue {
    $message!: typeof Message;
    locations: any[] = [];

    /* 页面直接字段 开始 */
    searchType: string = 'po';
    searchTypes = [
        { label: 'PU#', value: 'pu', field: 'fk_tms_order_group_id' },
        { label: 'PRO#', value: 'pro', field: 'tms_order_pro' },
        { label: 'PO#', value: 'po', field: 'tms_manifest_cust_po' },
    ];
    rows: any = [];
    rowsReturned: boolean = false;
    userSource: boolean = false;
    currentPageIndex = 0;
    rowsPerPage = 7;
    lastSearchText: string[] = [];
    editProductModal: string = 'payForSelectedInvoices';
    currentPageRows: Array<any> = [];
    searchText: string[] = [];
    status_type: string = '';
    timeArr: any = [];
    allshipments: string = '';
    showFields: Record<string, boolean> = {
        pu: true,
        pro: true,
        order_po: true,
        order_ref: true,
        service: true,
        origin: true,
        requestedDate: true,
        readyDate: true,
        pickupReady: true,
        pickupClose: true,
        destination: true,
        deliveryDate: true,
        palletsStats: true,
        totalWeight: true,
        orderStatus: true,
        reason: true,
        scheduled: true
    };

    messageForYou: any = {
        reason: '',
        message: '',
    };
    previousRow: any = '';
    changePickDate: string = '';
    changePickRow: IShipment | null = null;

    isCustomizeFieldsActive: boolean = false;
    paging: any = {
        pageSize: 10,
        currentPage: 1,
        totalSize: 0,
    };

    isShowWalkthrough: Boolean = false;
    cloneFilterTables: IFilterTable[] = [];
    ShipmentIDSet: Set<string> = new Set();
    resChoosingUNIS: any = 'resChoosingUNIS';
    filesmodalName: any = 'FilesmodalName';
    changePickDateConfirm: any = 'changePickDateConfirm';
    isBusinessType: Boolean = false;
    isys: Boolean = false;
    PODfiles: any = '';
    showPODfiles: boolean = false;
    orderStatus: string = '';
    orderStatuses: Array<any> = [
        { label: 'All', value: '0' },
        { label: 'Pickup Created', value: '1' },
        { label: 'Pickup Dispatched', value: '2' },
        // { label: 'Pickup Complet ed', value: '3'},
        { label: 'In Transit', value: '4' },
        { label: 'Pending Delivery', value: '5-1' },
        { label: 'Out for Delivery', value: '5' },
        { label: 'Delivered', value: '6' },
    ];

    // 次日提货截止时间相关变量
    cutoffTime: string = '15:30'; // 默认值
    cutoffTimezone: string = 'America/Chicago'; // 默认值
    cutoffDialogVisible: boolean = false; // 截止时间提示弹窗
    cutoffDialogDate: string = ''; // 建议顺延的日期
    cutoffDialogTime: string = ''; // 格式化后的截止时间显示
    selectedReadyDate: string | null = null; // 用户当前选择的Ready date
    // originalReadyDate 在 template.ts 中定义

    tableFieldsObjs: Array<any> = [
        {
            label: 'Pickup Date',
            value: 'tms_order_pickup_date',
        },
        {
            label: 'Status',
            value: 'tms_order_stage',
        },
        {
            label: 'Scheduled',
            value: 'tms_order_group.tms_order_group_appointment_date',
            type: 'select',
            options: ['Yes', 'No']
        },
        {
            label: 'Service',
            value: 'tms_quote_from',
            type: 'service'
        },
        {
            label: 'Origin',
            value: 'wa1.location_code',
            type: 'text'
        },
        {
            label: 'Destination',
            value: 'wa2.location_code',
            type: 'text'
        },
        {
            label: 'Delivery Date',
            value: 'tms_order_appointment_delivery_date',
        },
    ];

    orderStatusOptions: Array<any> = [
        { label: 'All statuses', value: '-1' },
        { label: 'Pickup', value: '0' },
        { label: 'Pickup Complete', value: '2' },
        { label: 'In Transit', value: '3' },
        { label: 'Out For Delivery', value: '4' },
        { label: 'Delivery Complete', value: '5' },
    ];

    sortBy: string = 'desc'; // Default: descending order
    sortField: string = 'tms_order.tms_order_id'; // Default: sort by order ID
    changePickDateSuccessModal: string = 'changePickDate';
    updateSuccessModal = 'updateSuccess';
    FilterTables: Array<any> = [];
    isGettingOrderList = false;
    trackingGuestOrderId: any = '';
    isLoading = false;
    processedFilters: any[] = [];

    palletsStatsRenderedAt = Date.now();
    datarow: any = null;
    /**
     * Copy of datarow, both are IShipment type data
     */
    item: any = null;
    itemEditDialogKey = Date.now();
    itemEditDialogVisible = false;
    isItemUpdating = false;
    formValidated = false;

    isVendor = false;

    reasonOptions = [
        {
            label: 'Delayed Order',
            value: 'Delayed Order',
        }
    ];

    previousReadyDate: Date | string | null = null;
    previousReadyTime: string | null = null;
    previousCloseTime: string | null = null;
    
    // 添加以下三个属性用于在模板中判断
    hasChangedReadyDate: boolean = false;
    hasChangedReadyTime: boolean = false;
    hasChangedCloseTime: boolean = false;

    changeRecordDialogVisible = false;
    changeRecordData: Array<{
        changed_at: string;
        field: string;
        reason: string;
        old_value: string;
        new_value: string;
        created_by: string;
        created_att: string;
    }> | null = null;

    // 默认字段配置
    defaultFieldsConfig: Array<{ id: string; label: string; visible: boolean }> = [
        { id: 'scheduled', label: 'Scheduled', visible: true },
        { id: 'pu', label: 'PU #', visible: true },
        { id: 'pro', label: 'PRO #', visible: true },
        { id: 'order_po', label: 'PO', visible: true },
        { id: 'order_ref', label: 'Reference', visible: true },
        { id: 'service', label: 'Service', visible: true },
        { id: 'origin', label: 'Origin', visible: true },
        { id: 'requestedDate', label: 'Requested date', visible: true },
        { id: 'readyDate', label: 'Ready date', visible: true },
        { id: 'pickupReady', label: 'Ready Time', visible: true },
        { id: 'pickupClose', label: 'Close Time', visible: true },
        { id: 'destination', label: 'Destination', visible: true },
        { id: 'appointmentDate', label: 'Delivery Appt Date', visible: true },
        { id: 'appointmentTime', label: 'Delivery Appt Time', visible: true },
        { id: 'deliveryDate', label: 'Delivery date', visible: true },
        { id: 'palletsStats', label: 'Pallets', visible: true },
        { id: 'totalWeight', label: 'Weight', visible: true },
        // 默认对所有用户都显示，但在后续初始化过程中会根据用户角色和保存的设置进行调整
        { id: 'orderStatus', label: 'Status', visible: true },
        { id: 'reason', label: 'Reason', visible: true },
    ];

    tableDataLoaded: boolean = false;

    get eyeIcon() {
        if (this.isCustomizeFieldsActive) {
            return require('@/assets/images/eye-active.svg');
        } else {
            return require('@/assets/images/eye.svg');
        }
    }

    get locationIds() {
        return this.locations.map(i => i.location_id);
    }

    get locationIdStrings() {
        const locationIdStrings = this.locations.map(i => i.location_id.toString());
        return locationIdStrings;
    }

    get isNotAble2Update() {
        return this.item.order_adjusted.filter((l: any) => !isEmptyAdjustedOrderLine(l)).length === 0;
    }

    get isDelete() {
        const currentIds = this.item.order_adjusted.map((i: IAdjustedOrderLineDto) => i.id).filter((id: number | string) => id != 0);
        const isDelete = Array.from(this.ShipmentIDSet).every((id: string) => currentIds.includes(id));
        return !isDelete;
    }

    get isDeleteAndIsNote() {
        const isNote = this.item.order_note.length === 0;
        return this.isDelete && isNote;
    }

    async mounted() {
        const savedFilters = localStorage.getItem('shipmentFilters');
        if (savedFilters) {
            const filters = JSON.parse(savedFilters);
            this.searchText = filters.searchText || [];
            this.lastSearchText = filters.searchText || [];
            this.searchType = filters.searchType || 'po';
            this.FilterTables = filters.FilterTables || [];
            this.cloneFilterTables = filters.cloneFilterTables || [];
            this.paging = filters.paging || this.paging; // 恢复分页状态
        }

        this.init();
        if (this.$route.query && this.$route.query.locationIds) {
            const locationId = this.$route.query.locationIds as string;
            this.$set(this.locationIds, 0, locationId);
        }
        this.locations = await getCustomerAccount();

        // 获取次日提货截止时间
        await this.fetchCutoffTime();

        this.filterTableSearch(this.paging.currentPage, this.paging.pageSize);
        localStorage.removeItem('shipmentFilters');
    }

    @Watch('locationIds')
    onLocationIdsChange() {
        this.filterTableSearch(this.paging.currentPage, this.paging.pageSize);
    }

    closeModal() {
        this.$modal.hide(this.changePickDateSuccessModal);
    }

    closeUpdateSuccessModal() {
        this.$modal.hide(this.updateSuccessModal);
    }

    addFilterTables() {
        this.FilterTables.push({
            filter: '',
            or: '',
            value: '',
        });
    }

    updateCurrentPageIndex(index: number) {
        this.currentPageIndex = index;
    }

    getList(page: { pageSize: number; currentPage: number }) {
        this.paging.pageSize = page.pageSize;
        this.filterTableSearch(page.currentPage);
    }

    async fetchData(page: number) {
        if (this.locationIds.length === 0) {
            return;
        }

        try {
            this.isGettingOrderList = true;

            // Make the API call with the processed filters
            const response = await tmsServiceBackend.post('/cpv2/orders/list', {
                page: page || this.paging.currentPage,
                ...this.paging,
                FilterTables: this.processedFilters
            });

            // Handle the response
            if (response.status === 200) {
                // Update your data here
                this.rows = response.data.rows;
                this.paging = response.data.paging;
            }

        } catch (error) {
            this.err(error);
        } finally {
            this.isGettingOrderList = false;
        }
    }

    get getSearchPlaceholder(): string {
        return `Enter one or multiple on separate lines. Separated by spaces or commas`;
    }

    searchShipmentsByinput() {
        this.FilterTables = this.FilterTables.filter(filter =>
            filter.filter !== 'fk_tms_order_group_id' && filter.filter !== 'tms_order_pro' && filter.filter !== 'tms_manifest_cust_po'
        );

        if (this.searchText && this.searchText.length > 0) {
            if (this.searchType === 'pu') {
                this.FilterTables.push({
                    filter: 'fk_tms_order_group_id',
                    or: 'is',
                    value: this.searchText
                });
            } else if (this.searchType === 'pro') {
                this.FilterTables.push({
                    filter: 'tms_order_pro',
                    or: 'is',
                    value: this.searchText
                });
            } else if (this.searchType === 'po') {
                this.FilterTables.push({
                    filter: 'tms_manifest_cust_po',
                    or: 'is',
                    value: this.searchText
                });
            }
        }

        if (!this.searchText || this.searchText.length === 0) {
            let fullUrl: any = window.location.href;
            let hashPart: any = fullUrl.split('#')[1] || '';
            const searchText = hashPart.split('searchText=')[1];
            if (searchText) {
                const newUrl = fullUrl.replace(searchText, '');
                window.history.replaceState(null, '', newUrl);
            }
        }

        // 更新 cloneFilterTables
        this.cloneFilterTables = JSON.parse(JSON.stringify(this.FilterTables));
        this.filterTableSearch(1);
    }

    searchShipments() {
        this.FilterTables = [];
        this.filterTableSearch(1);
    }

    showReset() {
        this.FilterTables = [
            {
                filter: '',
                or: '',
                value: '',
            },
        ];
    }
    closeReset() {
        if (this.cloneFilterTables && Array.isArray(this.cloneFilterTables) && this.cloneFilterTables.length > 0) {
            this.FilterTables = JSON.parse(JSON.stringify(this.cloneFilterTables));
        }
        this.$modal.hide(this.editProductModal);
    }

    filters() {
        // this.FilterTables 过滤掉 pro 和 pu
        const table = this.FilterTables.filter((filter: any) => filter.filter !== 'tms_order_pro' && filter.filter !== 'fk_tms_order_group_id' && filter.filter !== 'tms_manifest_cust_po');
        if (!table || table.length === 0) {
            this.cloneFilterTables = JSON.parse(JSON.stringify(this.FilterTables));

            if (!Array.isArray(this.FilterTables) || this.FilterTables.length === 0) {
                this.FilterTables = [
                    {
                        filter: '',
                        or: '',
                        value: '',
                    },
                ];
            } else {
                this.FilterTables.push({
                    filter: '',
                    or: '',
                    value: '',
                });
            }

        } else {
            // Create backup of current filters
            this.cloneFilterTables = JSON.parse(JSON.stringify(this.FilterTables));
        }

        this.$modal.show(this.editProductModal);
    }

    applyFilters() {
        const filterCount = this.FilterTables.filter(item => item && item.filter).length;
        analytics.trackButtonClick({ buttonName: 'apply_shipper_shipment_filters' });
        analytics.trackFilterApply({ filterType: 'shipper_shipment', filterCount });
        this.filterTableSearch(1);
    }

    removeFilter(index: any) {
        this.FilterTables.splice(index, 1);
    }

    buildSearchStr() {
        let search_list: Record<string, string[]> = {};
        forEach(this.searchText, searchText => {
            let keyword: string[] = [];

            keyword = [
                this.searchType,
                searchText
            ];

            if (searchText.indexOf(':') !== -1) {
                keyword = searchText.split(':');
            }

            let field_name = keyword[0].toLowerCase();
            if (search_list[field_name]) {
                search_list[field_name].push(keyword[1]);
            } else {
                search_list[field_name] = [keyword[1]];
            }
        });

        let search_str_list: string[] = [];
        forEach(search_list, (value, key) => {
            key = key.toLowerCase();
            if (value.length > 0) {
                const searchType = this.searchTypes.find(type => type.value === key);
                if (searchType) {
                    if (searchType?.field === 'tms_manifest_cust_po') {
                        if (Array.isArray(value) && value.length > 0) {
                            const values = value.map(v => `'${v}'`).join(',');
                            search_str_list.push(`tms_order.tms_order_id IN (SELECT fk_tms_order_id FROM tms_manifest WHERE tms_manifest_cust_po IN (${values}))`);
                        }
                    } else {
                        let keyfiled = searchType!.field;
                        if (searchType!.field === 'fk_tms_order_group_id') {
                            keyfiled = 'tms_order.fk_tms_order_group_id';
                        }
                        search_str_list.push(`${keyfiled} IN ('${value.join("','")}')`);
                    }
                }
            }
        });

        return search_str_list.length > 0 ? `(${search_str_list.join(' OR ')})` : '';
    }

    buildFilterStr(filter: string, or: string, value: string | string[] | Date[], is_export: boolean = false) {
        if (filter === 'fk_tms_order_group_id') {
            filter = 'tms_order.fk_tms_order_group_id';
        }

        if (filter === 'tms_order_pickup_date' || filter === 'tms_order_appointment_delivery_date') {
            if (Array.isArray(value) && value.length === 2) {
                const endDate = new Date(value[1] as string);
                endDate.setDate(endDate.getDate() + 1);
                const formattedEndDate = endDate.toISOString().split('T')[0];

                if (filter === 'tms_order_pickup_date') {
                    return `${filter} >= '${value[0]}' AND ${filter} < '${formattedEndDate}' `;
                }

                if (filter === 'tms_order_appointment_delivery_date') {
                    return `((tms_order_appointment_delivery_date >= '${value[0]}' AND tms_order_appointment_delivery_date < '${formattedEndDate}') OR (tms_order_delivery_date_actual >= '${value[0]}' AND tms_order_delivery_date_actual < '${formattedEndDate}'))`;
                }
            }
            return '';
        }

        // Handle Scheduled filter (using appointment date)
        if (filter === 'tms_order_group.tms_order_group_appointment_date') {
            if (value === 'Yes' || (Array.isArray(value) && value.some((v: any) => v === 'Yes'))) {
                return or === 'is' 
                    ? `${filter} IS NOT NULL AND ${filter} != '' AND tms_order_group.tms_order_group_appointment_date_origin IS NOT NULL AND tms_order_group.tms_order_group_appointment_date_origin != ''` 
                    : `(${filter} IS NULL OR ${filter} = '' OR tms_order_group.tms_order_group_appointment_date_origin IS NULL OR tms_order_group.tms_order_group_appointment_date_origin = '')`;
            } else if (value === 'No' || (Array.isArray(value) && value.some((v: any) => v === 'No'))) {
                return or === 'is' 
                    ? `(${filter} IS NULL OR ${filter} = '' OR tms_order_group.tms_order_group_appointment_date_origin IS NULL OR tms_order_group.tms_order_group_appointment_date_origin = '')` 
                    : `${filter} IS NOT NULL AND ${filter} != '' AND tms_order_group.tms_order_group_appointment_date_origin IS NOT NULL AND tms_order_group.tms_order_group_appointment_date_origin != ''`;
            }
            return '';
        }

        if (filter === 'tms_order_stage') {
            // Handle empty or -1 (All statuses) value
            if (!value || (Array.isArray(value) && value.every(v => typeof v === 'string') && (value.indexOf('-1') !== -1 || value.length === 0))) {
                return '';
            }

            // Convert single value to array for consistent handling
            const statusValues = Array.isArray(value) ? value : [value];

            // Special handling for status '3'
            const hasStatus3 = Array.isArray(statusValues) && statusValues.every(v => typeof v === 'string') && statusValues.indexOf('3') !== -1;
            if (hasStatus3) {
                const otherStatuses = statusValues.filter(v => v !== '3');
                const status3Condition = or === 'is'
                    ? 'tms_order_stage IN (1, 1.1, 1.2, 1.3, 3)'
                    : 'tms_order_stage NOT IN (1, 1.1, 1.2, 1.3, 3)';

                if (otherStatuses.length === 0) {
                    return status3Condition;
                }

                const otherCondition = or === 'is'
                    ? `tms_order_stage IN ('${otherStatuses.join("','")}')`
                    : `tms_order_stage NOT IN ('${otherStatuses.join("','")}')`;

                return or === 'is'
                    ? `(${status3Condition} OR ${otherCondition})`
                    : `(${status3Condition} AND ${otherCondition})`;
            }

            // Regular status handling
            return or === 'is'
                ? `tms_order_stage IN ('${statusValues.join("','")}')`
                : `tms_order_stage NOT IN ('${statusValues.join("','")}')`;
        }

        if (is_export && value === 'LTL shipment') {
            if (filter === 'tms_freight_type_name') {
                return `tms_freight_type = 0`;
            }
        }

        if (filter === 'tms_manifest_cust_po') {
            if (Array.isArray(value) && value.length > 0) {
                const values = value.map(v => `'${v}'`).join(',');
                return or === 'is'
                    ? `tms_order.tms_order_id IN (SELECT fk_tms_order_id FROM tms_manifest WHERE tms_manifest_cust_po IN (${values}))`
                    : `tms_order.tms_order_id NOT IN (SELECT fk_tms_order_id FROM tms_manifest WHERE tms_manifest_cust_po IN (${values}))`;
            } else if (typeof value === 'string' && value) {
                return or === 'is'
                    ? `tms_order.tms_order_id IN (SELECT fk_tms_order_id FROM tms_manifest WHERE tms_manifest_cust_po = '${value}')`
                    : `tms_order.tms_order_id NOT IN (SELECT fk_tms_order_id FROM tms_manifest WHERE tms_manifest_cust_po = '${value}')`;
            }
            return '';
        }

        // Handle array values
        if (Array.isArray(value) && value.length > 0) {
            const values = value.map(v => `'${v}'`).join(',');
            if (or === 'is') {
                return `${filter} IN (${values})`;
            } else {
                return `${filter} NOT IN (${values})`;
            }
        }

        let keyValue = `${filter}`;
        if (or === 'is') keyValue = keyValue + '=';
        if (or === 'is not') keyValue = keyValue + '!=';
        if (or === 'before') keyValue = keyValue + '<';
        if (or === 'after') keyValue = keyValue + '>';
        keyValue = keyValue + `'${value}'`;
        return keyValue;
    }

    handleSortChange({ column, prop, order }: { column: any; prop: string; order: string | null }) {
        if (prop === 'pickup_date') {
            this.sortField = 'pickup_date'; // 后端字段名
            this.sortBy = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : 'desc';
            this.filterTableSearch(1); // 重新加载数据
        } else if (prop === 'scheduled') {
            // Update to match backend logic for ready_date
            // A shipment is scheduled only if both tms_order_group_appointment_date_origin and tms_order_group_appointment_date have values
            const sortDirection = order === 'ascending' ? 'asc' : 'desc';
            // Using CASE expression to prioritize records that have both fields
            this.sortField = `CASE WHEN tms_order_group.tms_order_group_appointment_date IS NOT NULL 
                                 AND tms_order_group.tms_order_group_appointment_date != '' 
                                 AND tms_order_group.tms_order_group_appointment_date_origin IS NOT NULL 
                                 AND tms_order_group.tms_order_group_appointment_date_origin != '' 
                              THEN 1 ELSE 0 END`;
            this.sortBy = sortDirection;
            this.filterTableSearch(1); // Reload data
        } else if (prop === 'origin') {
            // 处理 Origin 列排序
            // 使用 CONCAT 函数将两个字段合并为一个字符串进行排序
            // 这样可以确保按照显示值的字母顺序排序
            this.sortField = "CONCAT(IFNULL(origin_pickup_name, ''), IFNULL(pickup_name, ''))";
            this.sortBy = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : 'desc';
            this.filterTableSearch(1); // 重新加载数据
        }
    }
    async sendEdiRequest(tms_order_group_id: any) {
        tmsServiceBackend.post('/order/update_edi', {
            tms_order_group_id: tms_order_group_id,
        });
    }

    filterTableSearch(page: any, size?: any, success_func?: () => void) {
        if (this.locationIds.length === 0) {
            return;
        }

        this.$modal.hide(this.editProductModal);
        let params: any = {
            request_from: 'clientApp',
            sort_field: this.sortField,
            sort: this.sortBy,
        };
        params.filter_str = [];
        params.locations = this.locationIds.join(',');
        params.page = page;
        if (this.status_type && this.status_type != '0') {
            if (this.status_type == '5-1') {
                params.status_type = '5';
                params.is_trip_order_created_from_lh = '1';
            } else {
                if (this.status_type == '5') {
                    params.is_trip_order_created_from_lh = '0';
                }
                params.status_type = this.status_type;
            }
        }
        params.page_size = this.paging.pageSize;
        this.cloneFilterTables = cloneDeep(this.FilterTables);
        if (!this.FilterTables) {
            this.FilterTables = [];
        }
        if (this.FilterTables.length == 0) {
            params.filter_str.push(
                this.buildFilterStr('tms_order_stage', 'is', '0', false)
            );
        }

        // 处理时间范围
        forEach(this.FilterTables, Filter => {
            if (!Filter.filter) {
                return;
            }

            const filterStr = this.buildFilterStr(Filter.filter, Filter.or, Filter.value, false);
            if (filterStr) {
                params.filter_str.push(filterStr);
            }
        });

        if (this.searchText.length > 0) {
            params.filter_str.push(this.buildSearchStr());
        }

        this.isGettingOrderList = true;
        tmsServiceBackend.post('/cpv2/orders/by/location', qs.stringify(params)).then(
            (response: any) => {
                if (!response.data.status || response.data.status != 1) {
                    this.err('Failed to get order list');
                    this.isGettingOrderList = false;
                    return;
                }

                this.currentPageIndex = 0;
                this.currentPageRows = preprocess(response.data.data.data);
                this.paging.totalSize = response.data.data.total;
                this.paging.currentPage = response.data.data.current_page;
                if (!this.currentPageRows) {
                    this.paging.totalSize = 0;
                    this.paging.currentPage = 0;
                }
                if (this.currentPageRows && this.currentPageRows.length == 0) {
                    this.paging.totalSize = 0;
                    this.paging.currentPage = 0;
                }
                this.isGettingOrderList = false;
                if (success_func) {
                    success_func();
                }
            },
            (err: any) => {
                this.err(err);
                this.isGettingOrderList = false;
            }
        );
    }

    onClickrow(item: any) {
        this.trackingGuestOrderId = item.order_id;
        this.$router.push({
            name: 'shipments-4-shippers-order-details',
            params: {
                orderId: item.order_id,
            },
        });
    }

    UserWalkNext() {
        this.isBusinessType = localStorage.getItem('guideDone') == 'true' ? true : false;
        let guideDoneStageNumber = Number(localStorage.getItem('guideDoneStageNumber'));
        if (!this.isBusinessType && (!guideDoneStageNumber || guideDoneStageNumber < 3)) {
            this.$modal.show(this.resChoosingUNIS);
            localStorage.removeItem('guideDoneStage');
            util.showUserWalkNext('', this);
        }
    }

    restartWalkthrough() {
        let stageNumber = localStorage.getItem('guideDoneStageNumber');
        if (stageNumber) {
            if (stageNumber && Number(stageNumber) == 2)
                tmsServiceBackend.post(`/cpv2/userGuide/increaseShowTimes`);
            localStorage.setItem('guideDoneStageNumber', String(Number(stageNumber) + 1));
        } else localStorage.setItem('guideDoneStageNumber', '1');
        this.$modal.hide(this.resChoosingUNIS);
        localStorage.setItem('guideDoneStage', 'Dashboard');
        this.$router.replace({
            name: 'Home',
        });
        util.showUserWalkthrough();
    }

    closeandreturntodashboard() {
        localStorage.setItem('guideDoneStageNumber', '3');
        localStorage.setItem('guideDone', 'true');
        this.$modal.hide(this.resChoosingUNIS);
        this.$router.replace({
            name: 'Home',
        });
    }

    doNotShowUserWalkthrough(isShowWalkthrough: any) {
        if (!isShowWalkthrough) {
            tmsServiceBackend.post(`/cpv2/userGuide/complete`).then(
                (res: any) => {
                    localStorage.setItem('guideDoneStageNumber', '3');
                    localStorage.setItem('guideDone', 'true');
                },
                (err: any) => {}
            );
        }
    }

    isgotItGettings: any = false;
    loadingExcel: boolean = false;

    gotItfinished(name: any) {
        if (this.currentPageRows.length > 0) {
            this.isgotItGettings = true;
            localStorage.setItem('guideDoneStage', 'finished');
            this.onClickrow(this.currentPageRows[0]);
        } else {
            this.UserWalkNext();
        }
    }

    closeFilesmodalName() {
        this.$modal.hide(this.filesmodalName);
    }
    handleDateFocus(row: IShipment) {
        this.previousReadyDate = row.ready_date || null;
        this.previousReadyTime = row.pickup_ready || null;
        this.previousCloseTime = row.pickup_close || null;
        this.previousRow = { ...row };
    }

    async rquestUpdateReadyDate(item: IShipment, date: string) {
        this.messageForYou.reason = 'Product Not Ready';
        this.messageForYou.message = '';

        this.changePickDate = date;
        this.changePickRow = item;
        this.previousReadyDate = item.ready_date || null;
        this.previousReadyTime = item.pickup_ready || null;
        this.previousCloseTime = item.pickup_close || null;

        this.$modal.show(this.changePickDateConfirm);
    }

    async rquestUpdateReadyTime(v: string, item: IShipment) {
        this.messageForYou.reason = 'Product Not Ready';
        this.messageForYou.message = '';

        this.changePickRow = item;
        this.previousReadyDate = item.ready_date || null;
        this.previousReadyTime = item.pickup_ready || null;
        this.previousCloseTime = item.pickup_close || null;

        // 保存新的ready time值
        item.pickup_ready = v;

        this.$modal.show(this.changePickDateConfirm);
    }

    async rquestUpdateCloseTime(v: string, item: IShipment) {
        this.messageForYou.reason = 'Product Not Ready';
        this.messageForYou.message = '';

        this.changePickRow = item;
        this.previousReadyDate = item.ready_date || null;
        this.previousReadyTime = item.pickup_ready || null;
        this.previousCloseTime = item.pickup_close || null;

        // 保存新的close time值
        item.pickup_close = v;

        this.$modal.show(this.changePickDateConfirm);
    }


    closeChangePickDateConfirm(only_close: boolean) {
        // 无论通过什么方式关闭(点击X或点击外部)，都不应该更新原始数据
        // 只有在提交成功后才更新原始数据(在handleSubmitMessageForYou中处理)
        
        // 清理所有临时存储变量
        this.previousReadyDate = null;
        this.previousReadyTime = null;
        this.previousCloseTime = null;
        this.changePickRow = null;
        this.previousRow = null;
        this.$modal.hide(this.changePickDateConfirm);
    }

    async exportFileAciton() {
        if (this.locationIds.length === 0) {
            return;
        }

        let filter_strs: any = [];
        let status_type: any = '';
        let is_trip_order_created_from_lh: any = '';
        if (this.FilterTables.length > 0) {
            let filterTables = this.FilterTables[0].filter
            ? this.FilterTables
            : this.cloneFilterTables.length > 0
            ? this.cloneFilterTables
            : [];
            forEach(filterTables, Filter => {
                // Process time ranges
                if (!Filter.filter) {
                    return;
                }

                const filterStr = this.buildFilterStr(Filter.filter, Filter.or, Filter.value, true);
                if (filterStr) {
                    filter_strs.push(filterStr);
                }
            });
        }


        if (this.status_type && this.status_type != '0') {
            status_type = this.status_type;
            if (this.status_type == '5-1') {
                status_type = '5';
                is_trip_order_created_from_lh = '1';
            }
            if (this.status_type == '5') {
                status_type = '5';
                is_trip_order_created_from_lh = '0';
            }
        }

        this.loadingExcel = true;
        let _this = this;

        tmsServiceBlob
            .post(
                '/apinew/excel/shipper/export',
                qs.stringify({
                    billto: this.locationIds[0],
                    // search_text: this.searchText,
                    status_type: status_type,
                    is_trip_order_created_from_lh: is_trip_order_created_from_lh,
                    filter_str: filter_strs,
                    from: 'shipper_portal',
                    locations: this.locationIds.join(','),
                })
            )
            .then(function(response: any) {
                if (response.data.type == 'application/json') {
                    const data = new FileReader();
                    data.readAsText(response.data, 'utf-8');
                    data.onload = () => {
                        let dataResult: any = data.result;
                        let parseObj = JSON.parse(dataResult);
                        _this.err(parseObj.message);

                        _this.loadingExcel = false;
                        return;
                    };
                } else {
                    _this.cloneFilterTables = [];
                    _this.FilterTables = [
                        {
                            filter: '',
                            or: 'is',
                            value: '',
                        },
                    ];
                    let result = response.data;
                    _this.loadingExcel = false;
                    let date = new Date(+new Date() + 8 * 3600 * 1000)
                        .toJSON()
                        .substr(0, 19)
                        .replace('T', '');
                    let fileName = 'Shipments_export_' + date + '.xls';
                    let downloadUrl = URL.createObjectURL(result);
                    let a = document.createElement('a');
                    a.href = downloadUrl;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    analytics.trackFileDownload({
                        fileName: 'shipper_shipments_export',
                        fileType: 'xls',
                    });
                }
            })
            .catch (function(error) {
                _this.loadingExcel = false;
                _this.err(error);
            });
    }

    async chargeTrack(searchInfo: any) {
        this.trackingGuestOrderId = '';
        this.searchText = searchInfo;
        this.replaceUrl(searchInfo);
        this.filterTableSearch(1);
    }

    replaceUrl(searchInfo: any) {
        let currentUrl = window.location.href;
        const hashIndex = currentUrl.indexOf('#');
        if (hashIndex !== -1) {
            currentUrl = currentUrl.substring(0, hashIndex);
        }
        if (currentUrl.includes('?')) {
            if (currentUrl.includes('locationIds=')) {
                currentUrl = currentUrl.replace(/locationIds=[^&]+/, `locationIds=${this.locationIds[0]}`);
            } else {
                currentUrl += `&locationIds=${this.locationIds[0]}`;
            }
        } else {
            currentUrl += `?locationIds=${this.locationIds[0]}`;
        }
        window.history.replaceState({}, '', currentUrl + window.location.hash);
    }

    init() {
        // Initialize time array
        this.timeArr = this.generateTimeArray();
    }

    /**
     * Generate time array with 15-minute intervals
     */
    generateTimeArray() {
        const timeArr = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 15) {
                const formattedHour = hour < 10 ? '0' + hour : '' + hour;
                const formattedMinute = minute < 10 ? '0' + minute : '' + minute;
                timeArr.push(`${formattedHour}:${formattedMinute}`);
            }
        }
        return timeArr;
    }

    async changeTime(item: IShipment) {
        // Change to call edit dialog
        this.openItemEditDialog(item);
    }

    updateRef(item: any) {
        updateReference(item).then(
            (res: any) => {
                if (res.status == 200) {
                    this.$modal.show(this.updateSuccessModal);
                }
            },
            (err: any) => {
                this.err(err.response.data.statusText);
            }
        );
    }

    /**
     * Save button click event handler of edit dialog
     * @returns
     */
    async updateItem() {
        if (!this.item || this.isItemUpdating) {
            return;
        }

        try {
            this.isItemUpdating = true;

            const deletedIds = Array.from(this.ShipmentIDSet).filter(
                id => !this.item.order_adjusted.map((i: IAdjustedOrderLineDto) => i.id).includes(id)
            );

            // Check if Ready date is editable
            const isReadyDateEditable = this.isReadyDateEditable(this.item);

            // Validate Pickup Times
            if (isReadyDateEditable) {
                const pickupTimesValidation = validatePickupTimes(this.item);
                if (!pickupTimesValidation.isValid) {
                    this.$message.error(`The following fields are required: ${pickupTimesValidation.missingFields.join(', ')}`);
                    this.isItemUpdating = false;
                    return;
                }
            }

            // Validate that each pallet line has a quantity greater than 0
            const nonEmptyLines = this.item.order_adjusted.filter(
                (l: IAdjustedOrderLineDto) => !isEmptyAdjustedOrderLine(l)
            );
            
            if (nonEmptyLines.length > 0 && !validatePalletCounts(nonEmptyLines)) {
                this.$message.error('Each row\'s pallet quantity must be greater than 0. Please enter a valid pallet quantity.');
                this.isItemUpdating = false;
                return;
            }

            let deletedIds2: string[] = [];
            if (this.isDelete) {
                const currentIds = new Set(this.item.order_adjusted.map((i: IAdjustedOrderLineDto) => i.id.toString()));
                deletedIds2 = Array.from(this.ShipmentIDSet).map(id => id.toString()).filter(id => !currentIds.has(id));
            }

            // Update Pickup Times
            let pickupTimesUpdateSuccess = true;
            
            try {
                if (isReadyDateEditable && (this.hasChangedCloseTime || this.hasChangedReadyDate || this.hasChangedReadyTime)) {
                    const res = await updateOrder(this.item, this.messageForYou.reason || '', this.messageForYou.message || '');
                    this.messageForYou.reason = '';
                    this.messageForYou.message = '';
                    pickupTimesUpdateSuccess = res && res.status === 200;

                    if (res && res.status === 200) {
                        // Find and update all matching rows in the table
                        this.$set(this.datarow, 'ready_date', this.item.ready_date);
                        this.$set(this.datarow, 'pickup_ready', this.item.pickup_ready);
                        this.$set(this.datarow, 'pickup_close', this.item.pickup_close);

                        this.$set(this.datarow, 'order_adjusted', res.data.data);
                        this.$set(this.datarow, 'order_note', this.item.order_note);
                        this.$set(this.datarow, 'order_po', getShipmentPO(this.item));
                        this.$set(this.datarow, 'order_reason', this.item.order_reason);
                        this.$set(this.datarow, 'order_ref', this.item.order_ref);
                        this.$set(this.datarow, 'palletsStats', countPallets(this.item));
                        this.$set(this.datarow, 'total_weight', calcTotalWeight(this.item));
        
                        // Trigger rendering update
                        this.palletsStatsRenderedAt = Date.now();
                        
                        this.itemEditDialogVisible = false;
                        this.$modal.show(this.updateSuccessModal);
                    }
                } else {
                    // 当Ready date不可编辑时，仍然需要更新reference
                    const itemToUpdate = JSON.parse(JSON.stringify(this.item)); // 使用this.item而不是FilterTables
                    itemToUpdate.ready_date   = '';
                    itemToUpdate.pickup_ready = '';
                    itemToUpdate.pickup_close = '';
                    const referenceRes = await updateOrder(itemToUpdate, '', '');
                    if (referenceRes && referenceRes.status === 200) {
                        // 更新表格中的数据
                        this.$set(this.datarow, 'order_adjusted', referenceRes.data.data);
                        this.$set(this.datarow, 'order_note', this.item.order_note);
                        this.$set(this.datarow, 'order_po', getShipmentPO(this.item));
                        this.$set(this.datarow, 'order_reason', this.item.order_reason);
                        this.$set(this.datarow, 'order_ref', this.item.order_ref);
                        this.$set(this.datarow, 'palletsStats', countPallets(this.item));
                        this.$set(this.datarow, 'total_weight', calcTotalWeight(this.item));
                        
                        // 触发重新渲染
                        this.palletsStatsRenderedAt = Date.now();
                        
                        this.itemEditDialogVisible = false;
                        this.$modal.show(this.updateSuccessModal);
                    }
                }
            } catch (error) {
                if (isReadyDateEditable) {
                    pickupTimesUpdateSuccess = false;
                }
                this.err(error);
            }
        } catch (error) {
            this.err(error);
        } finally {
            this.isItemUpdating = false;
        }
    }

    closeItemEditDialog() {
        this.ShipmentIDSet = new Set();
        this.itemEditDialogVisible = false;
        this.formValidated = false;
        this.item = null;
    }

    /**
     * 打开编辑弹窗时保存原始ready_date
     */
    openItemEditDialog(item: any) {
        this.datarow = item;
        this.item = cloneDeep(item);

        this.ShipmentIDSet = new Set(...[item.order_adjusted.map((i: IAdjustedOrderLineDto) => i.id)]);

        // 重置修改状态
        this.hasChangedReadyDate = false;
        this.hasChangedReadyTime = false;
        this.hasChangedCloseTime = false;
        
        // 记录初始值，用于后续比较是否修改
        this.previousReadyDate = this.item.ready_date;
        this.previousReadyTime = this.item.pickup_ready;
        this.previousCloseTime = this.item.pickup_close;
        
        // 保存原始日期，用于弹窗取消时恢复
        this.originalReadyDate = this.item.ready_date;

        // 设置初始reason值
        this.messageForYou.reason = '';
        this.messageForYou.message = '';

        if (!isArray(this.item.order_adjusted) || this.item.order_adjusted.length === 0) {
            // By default, need to add an empty row
            const line: Partial<IAdjustedOrderLineDto> = {
                id: 0,
                po: '',
                pallet: undefined,
                stackable: undefined,
                weight: undefined,
            };
            if (!isArray(this.item.order_adjusted)) {
                this.$set(this.item, 'order_adjusted', [line]);
                return;
            }
            this.$set(this.item.order_adjusted, this.item.order_adjusted.length, line);
        }

        // Check if item's Ready date is editable
        const isReadyDateEditable = this.isReadyDateEditable(this.item);

        this.itemEditDialogKey = Date.now();
        this.itemEditDialogVisible = true;
    }

    isDisabledDate(row: IShipment, time: any) {
        return isDisabledReadyDate(row, time);
    }

    async updateReadyDate(item: IShipment, date: string) {
        const res = await updateReadyDate(item, this.messageForYou.reason ?? '', this.messageForYou.message ?? '');
        if (res.status == 200) {
            this.$modal.show(this.updateSuccessModal);
        }
    }

    async removeAdjustedOrderLine(line: IAdjustedOrderLineDto) {
        /**
         * 至少保留一行
         */
        if (this.item.order_adjusted.length === 1) {
            return;
        }
        const remove = () => {
            this.item.order_adjusted.splice(
                this.item.order_adjusted.findIndex((i: IAdjustedOrderLineDto) => i == line),
                1
            );
        };
        if (line.id == 0) {
            remove();
            return Promise.resolve();
        }
        // await deleteOrderLine(line);
        remove();
    }

    async addAdjustedOrderLine() {
        if (!this.item) {
            return;
        }
        const line: Partial<IAdjustedOrderLineDto> = {
            id: 0,
            po: '',
            pallet: undefined,
            stackable: undefined,
            weight: undefined,
        };
        if (!isArray(this.item.order_adjusted)) {
            this.$set(this.item, 'order_adjusted', [line]);
            return;
        }
        this.$set(this.item.order_adjusted, this.item.order_adjusted.length, line);
    }

    showDetails(details: IShipment) {
        localStorage.setItem('ShipmentViewFrom', '2');
        if (!details.order_id) {
            return;
        }
        localStorage.setItem('shipmentFilters', JSON.stringify({
            searchText: this.searchText,
            searchType: this.searchType,
            FilterTables: this.FilterTables,
            cloneFilterTables: this.cloneFilterTables,
            paging: this.paging
        }));
        this.$router.push({
            name: 'shipments-4-shippers-shipment-view',
            params: {
                orderId: String(details.order_id),
                from: '1',
            },
        });
    }

    handleCommand(command: { action: string; data: IShipment }) {
        const handlers = {
            details: (dto: IShipment) => {
                this.showDetails(dto);
            },
            edit: (dto: IShipment) => {
                this.openItemEditDialog(dto);
            },
            'change-record': (dto: IShipment) => {
                this.showChangeRecordDialog(dto);
            }
        } as Record<string, (dto: IShipment) => void>;

        const func = handlers[command.action];
        if (!func) {
            return;
        }
        func(command.data);
    }

    async showChangeRecordDialog(details: IShipment) {
        if (!details.order_id) {
            return;
        }

        try {
            const res = await tmsServiceBackend.post(`/cpv2/orders/ready-time/record/${details.order_id}`);
            if (res.status == 200) {
                this.changeRecordData = res.data;
                this.changeRecordDialogVisible = true;
            }
        } catch (error) {
            this.err(error);
        }
    }

    closeChangeRecordDialog() {
        this.changeRecordDialogVisible = false;
        this.changeRecordData = null;
    }

    async exportChangeRecord() {
        if (!this.changeRecordData || this.changeRecordData.length === 0) {
            return;
        }

        try {
            // 直接使用现有的 changeRecordData
            const data = this.changeRecordData.map(record => ({
                'New Ready Date': record.new_value,
                'Original Ready Date': record.old_value,
                'Change Reason': record.reason,
                'Changed By': record.created_by,
                'Change Time': record.created_att
            }));

            // 将数据转换为 Excel Blob
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(data);
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const excelBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });


            // 生成文件名
            const date = new Date(+new Date() + 8 * 3600 * 1000)
                .toJSON()
                .substr(0, 19)
                .replace('T', ' ');
            const fileName = `Ready_Date_Change_Record_${date}.xlsx`;

            // 下载文件
            const downloadUrl = URL.createObjectURL(excelBlob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            analytics.trackFileDownload({
                fileName: 'ready_date_change_record',
                fileType: 'xlsx',
            });
            document.body.removeChild(link);
            URL.revokeObjectURL(downloadUrl);

        } catch (error) {
            this.err(error);
        }
    }

    get isValidFilters() {
        return this.FilterTables.every(item => {
            // 如果filter为空，说明用户还没有选择过滤条件，此时应该返回true
            if (!item.filter) {
                return false;
            }

            if (Array.isArray(item.value)) {
                return item.value.length > 0;
            } else {
                return item.value !== '' && item.value !== null && item.value !== undefined;
            }
        });
    }

    onFilterSelect(item: IFilterTable) {
        // 当选择了filter后，自动设置or为'is'并清空value
        if (item.filter) {
            item.or = 'is';
            // 清空之前的值
            item.value = this.isDateFilter(item) ? [] : [];
        }
    }

    isDateFilter(item: IFilterTable) {
        return item.filter === 'tms_order_pickup_date' ||
               item.filter === 'tms_order_appointment_delivery_date';
    }

    getFilterLabel(filter: { filter: string; or: string; value: any }) {
        const field = this.tableFieldsObjs.find(f => f.value === filter.filter);
        if (!field) return '';

        // Handle status field specially
        if (filter.filter === 'tms_order_stage') {
            const statusOption = this.orderStatusOptions.find(opt => opt.value === filter.value);
            const statusLabel = statusOption ? statusOption.label : filter.value;
            return `${field.label}: ${filter.or === 'is not' ? 'not ' : ''}${statusLabel}`;
        }

        // Handle service type field specially
        if (filter.filter === 'tms_quote_from') {
            return `${field.label}: ${filter.or === 'is not' ? 'not ' : ''}${filter.value}`;
        }

        // For date fields, show the date range
        if (filter.filter === 'tms_order_pickup_date' || filter.filter === 'tms_order_appointment_delivery_date') {
            if (Array.isArray(filter.value) && filter.value.length === 2) {
                return `${field.label}: ${filter.value[0]} to ${filter.value[1]}`;
            }
        }

        // For all other fields
        return `${field.label}: ${filter.or === 'is not' ? 'not ' : ''}${filter.value}`;
    }

    getFilterFieldLabel(filterKey: string): string {
        // Check if filterKey matches any searchType value and return its label
        const searchType = this.searchTypes.find(type => type.field === filterKey);
        if (searchType) {
            return searchType.label;
        }

        // 原有的逻辑保持不变
        const field = this.tableFieldsObjs.find(f => f.value === filterKey);
        return field ? field.label : filterKey;
    }

    /**
     * 检查托盘数量是否有错误
     * @param item 待检查的shipment数据
     * @returns 如果有托盘数量错误，返回true；否则返回false
     */
    hasPalletError(item: IShipment): boolean {
        if (!item || !item.order_adjusted || !Array.isArray(item.order_adjusted)) {
            return false;
        }
        
        // 过滤出非空行
        const nonEmptyLines = item.order_adjusted.filter(
            (l: IAdjustedOrderLineDto) => !isEmptyAdjustedOrderLine(l)
        );
        
        // 如果没有非空行，不显示错误
        if (nonEmptyLines.length === 0) {
            return false;
        }
        
        // 检查是否每个非空行都有有效的托盘数量（托盘数量>0）
        const hasValidPallets = nonEmptyLines.every((line: IAdjustedOrderLineDto) => line.pallet > 0);
        
        // 如果有无效的托盘数量，则显示错误
        return !hasValidPallets;
    }

    // Add method to remove filter and refresh
    removeAndRefreshFilter(index: number, filterKey: string) {
        if (this.FilterTables) {
            this.FilterTables = this.FilterTables.filter((_: any, i: number) => i !== index);
            this.cloneFilterTables = JSON.parse(JSON.stringify(this.FilterTables));
            this.filterTableSearch(1);
        }

        if (filterKey === 'tms_order_pro' || filterKey === 'fk_tms_order_group_id' || filterKey === 'tms_manifest_cust_po') {
            this.searchText = [];
        }
    }

    onPickupTimeChange(v: string, item: IShipment) {
        this.changeTime(item);
    }

    onCloseTimeChange(v: string, item: IShipment) {
        this.changeTime(item);
    }

    // Add this method to class C
    removeArrayFilterValue(filterIndex: number, valueIndex: number) {
        const filterTable = this.FilterTables[filterIndex];

        if (filterTable && Array.isArray(filterTable.value)) {
            const filterValues = filterTable.value as string[];
            filterValues.splice(valueIndex, 1);

            // Update the filter values
            filterTable.value = filterValues;

            // If the array becomes empty, remove the entire filter
            if (filterValues.length === 0) {
                this.removeAndRefreshFilter(filterIndex, filterTable.filter);
            } else {
                // Update cloneFilterTables and refresh
                this.cloneFilterTables = JSON.parse(JSON.stringify(this.FilterTables));
                this.filterTableSearch(1);
            }
        }
    }

    getStatusLabel(value: string): string {
        const option = this.orderStatusOptions.find(opt => opt.value === value);
        return option ? option.label : value;
    }

    clearSearchText() {
        this.searchText = [];
        this.FilterTables = this.FilterTables.filter(filter =>
            filter.filter !== 'fk_tms_order_group_id' && filter.filter !== 'tms_order_pro' && filter.filter !== 'tms_manifest_cust_po'
        );
        this.cloneFilterTables = JSON.parse(JSON.stringify(this.FilterTables));
        this.filterTableSearch(1);
    }

    areSetsDifferent<T>(set1: Set<T>, set2: Set<T>): boolean {
        if (set1.size !== set2.size) return true;
        let isDifferent = false;
        set1.forEach(item => {
            if (!set2.has(item)) isDifferent = true;
        });
        return isDifferent;
    }

    handleInput(value: string | string[]) {
        if (!value) return;

        let splitValues: string[] = [];

        // If value is a string, split it by spaces, newlines, and commas
        if (typeof value === 'string') {
            splitValues = value.split(/[\s,\n]+/).filter((v: string) => v.trim());
        }
        // If value is already an array, split each item in the array
        else if (Array.isArray(value)) {
            // Process each array item and only keep the split values
            splitValues = value.reduce((acc: string[], item: string) => {
                const splits = item.split(/[\s,\n]+/).filter((v: string) => v.trim());
                return [...acc, ...splits];
            }, []);
        }

        // If we have values, update searchText
        if (splitValues.length > 0) {
            // Replace searchText with only the split values
            this.searchText = Array.from(new Set(splitValues));
        }

        const lastSet = new Set(this.lastSearchText);
        const newSet = new Set(this.searchText.map((item) => {
            if (item.includes(':')) {
                return item;
            }
            return `${this.searchType.toUpperCase()}:${item}`;
        }));

        if (this.areSetsDifferent(lastSet, newSet)) {
            this.filterTableSearch(1);
            this.lastSearchText = Array.from(newSet);
        }

        this.searchText = Array.from(newSet);
    }

    // 获取字段的选项
    getFieldOptions(filter: string): any[] {
        const field = this.tableFieldsObjs.find(f => f.value === filter);
        if (!field) return [];

        switch (field.type) {
            case 'status':
                return this.orderStatusOptions;
            case 'service':
                return [
                    { label: 'LTL shipment', value: 'LTL shipment' },
                    { label: 'Shared Truckload', value: 'Shared Truckload' },
                    { label: 'Last Mile', value: 'Last Mile' }
                ];
            case 'select':
                return field.options?.map((opt: string) => ({ label: opt, value: opt })) || [];
            default:
                return [];
        }
    }

    // 判断字段类型
    getFieldType(filter: string): string {
        const field = this.tableFieldsObjs.find(f => f.value === filter);
        return field?.type || 'text';
    }

    // 在 created 生命周期中加载保存的字段配置
    async created() {
        // Set vendor flag from localStorage
        const isVendorStr = localStorage.getItem('IsVendor');
        this.isVendor = isVendorStr === '1';

        // If user is a vendor, remove the Status field from tableFieldsObjs
        if (this.isVendor) {
            // Filter out the Status field from tableFieldsObjs
            this.tableFieldsObjs = this.tableFieldsObjs.filter(field => 
                field.label !== 'Status' && field.value !== 'tms_order_stage'
            );

            this.defaultFieldsConfig = this.defaultFieldsConfig.filter(field => 
                field.label !== 'Status' && field.id !== 'orderStatus'
            );

            this.defaultFieldsConfig.map(f => ({ id: f.id, visible: f.visible }));
        }
        
        // 初始化字段可见性
        this.initializeFieldsVisibility();

        // 初始化其他数据
        this.initializeData();

        // 获取表格数据
        this.getTableData().catch (error => {
            this.$message.error('Failed to load shipments data. Please try again later.');
        });

        this.timeArr = this.generateTimeArray();
    }

    // Initialize fields visibility from localStorage if available
    initializeFieldsVisibility() {
        // 先使用默认配置初始化所有字段
        if (Array.isArray(this.defaultFieldsConfig)) {
            this.defaultFieldsConfig.forEach(field => {
                // 确保 field 不是 undefined 且有 id 属性
                if (field && field.id) {
                    // 使用 Vue.set 确保响应式更新
                    Vue.set(this.showFields, field.id, field.visible);
                }
            });
        }

        // 尝试从本地存储加载用户配置
        try {
            // 安全地获取用户 ID
            const userId = this.getUserStorageId();
            // 使用用户ID和IsVendor标志来创建唯一键
            const storageKey = this.getVisibilityStorageKey();

            const savedSettings = localStorage.getItem(storageKey);

            if (savedSettings) {
                const parsedSettings = JSON.parse(savedSettings);
                let hasChanges = false;

                // 将保存的设置合并到 showFields
                Object.keys(parsedSettings).forEach(fieldId => {
                    if (fieldId && Object.prototype.hasOwnProperty.call(this.showFields, fieldId)) {
                        // 只有当值不同时才更新，避免不必要的响应式更新
                        if (this.showFields[fieldId] !== parsedSettings[fieldId]) {
                            Vue.set(this.showFields, fieldId, parsedSettings[fieldId]);
                            hasChanges = true;
                        }
                    } else if (fieldId === 'orderStatus') {
                        // 特殊处理orderStatus字段
                        Vue.set(this.showFields, fieldId, parsedSettings[fieldId]);
                        hasChanges = true;
                    }
                });
                
                // 只对 vendor 用户强制隐藏 orderStatus
                if (this.isVendor && this.showFields.orderStatus === true) {
                    console.log('[DEBUG] User is vendor, forcing orderStatus to be hidden');
                    Vue.set(this.showFields, 'orderStatus', false);
                    hasChanges = true;
                }
                
                if (hasChanges) {
                    // 保存更新后的设置
                    localStorage.setItem(storageKey, JSON.stringify(this.showFields));
                }
            }
        } catch (error) {
            console.error('[DEBUG] Error loading field visibility settings:', error);
            // 加载失败时使用默认设置
        }

        // 确保 scheduled 字段有一个明确的布尔值
        if (this.showFields.scheduled === undefined) {
            Vue.set(this.showFields, 'scheduled', true);
        }

        // 触发表格重新渲染
        this.$nextTick(() => {
            // 通过修改一个不影响显示的属性来触发表格重新渲染
            this.palletsStatsRenderedAt = Date.now();
        });
    }

    // 获取当前用户存储ID
    getUserStorageId(): string {
        // 优先使用 UserID
        const userID = localStorage.getItem('UserID');
        if (userID) {
            return userID;
        }
        
        // 其次使用 store 中的用户ID
        if (this.$store && this.$store.state && this.$store.state.user && this.$store.state.user.id) {
            return this.$store.state.user.id;
        }
        
        // 否则生成一个基于 IsVendor 的ID
        const vendorFlag = localStorage.getItem('IsVendor') || '0';
        return `user-${vendorFlag}`;
    }
    
    // 获取可见性设置的存储键
    getVisibilityStorageKey(): string {
        const userId = this.getUserStorageId();
        const vendorFlag = localStorage.getItem('IsVendor') || '0';
        return `${userId}_${vendorFlag}_shipments_fields_visibility`;
    }

    // 处理字段更新
    handleFieldsUpdated(fields: Array<{ id: string; visible: boolean }>) {
        // 确保 fields 是数组且不为空
        if (!Array.isArray(fields) || fields.length === 0) {
            return;
        }

        let hasChanges = false;

        // 更新 showFields 对象，确保与字段可见性设置同步
        fields.forEach(field => {
            // 确保 field 不是 undefined 且有 id 属性
            if (field && field.id) {
                // 确保字段可见性是布尔值
                if (field.visible === undefined) {
                    field.visible = true;
                }

                // 特殊处理 orderStatus 字段 - 跳过，稍后统一处理
                if (field.id === 'orderStatus') {
                    return;
                }

                // 确保 field.id 存在于 showFields 中
                if (Object.prototype.hasOwnProperty.call(this.showFields, field.id)) {
                    // 检查值是否发生变化
                    if (this.showFields[field.id] !== field.visible) {
                        // 使用 Vue.set 确保响应式更新
                        Vue.set(this.showFields, field.id, field.visible);
                        hasChanges = true;
                    }
                } else {
                    // 如果字段不存在于 showFields 中，添加它
                    Vue.set(this.showFields, field.id, field.visible);
                    hasChanges = true;
                }
            }
        });

        // 专门处理 orderStatus 字段
        const orderStatusField = fields.find(f => f.id === 'orderStatus');
        if (orderStatusField) {
            
            // 如果用户是 vendor，强制隐藏 orderStatus
            if (this.isVendor) {
                if (this.showFields.orderStatus !== false) {
                    Vue.set(this.showFields, 'orderStatus', false);
                    hasChanges = true;
                }
            } else {
                // 非 vendor 用户可以正常更新 orderStatus 可见性
                if (this.showFields.orderStatus !== orderStatusField.visible) {
                    Vue.set(this.showFields, 'orderStatus', orderStatusField.visible);
                    hasChanges = true;
                }
            }
        } else {
            // 如果没有 orderStatus 字段，根据用户类型设置默认值
            const defaultVisibility = !this.isVendor;
            if (this.showFields.orderStatus !== defaultVisibility) {
                Vue.set(this.showFields, 'orderStatus', defaultVisibility);
                hasChanges = true;
            }
        }

        // 确保所有默认字段都存在于 showFields 中
        this.defaultFieldsConfig.forEach(defaultField => {
            if (!Object.prototype.hasOwnProperty.call(this.showFields, defaultField.id)) {
                Vue.set(this.showFields, defaultField.id, defaultField.visible);
                hasChanges = true;
            }
        });
        
        // 如果有变化，保存到本地存储
        if (hasChanges) {
            // 保存到本地存储
            try {
                const storageKey = this.getVisibilityStorageKey();

                // 确保 scheduled 字段存在且有值
                if (this.showFields.scheduled === undefined) {
                    Vue.set(this.showFields, 'scheduled', true);
                }

                // 最后再次确认 orderStatus 基于 isVendor 的设置是正确的
                if (this.isVendor && this.showFields.orderStatus !== false) {
                    Vue.set(this.showFields, 'orderStatus', false);
                }
                
                localStorage.setItem(storageKey, JSON.stringify(this.showFields));

            } catch (error) {
                console.error('[DEBUG] Error saving field visibility settings:', error);
                // 保存失败时不做处理
            }

            // 触发表格重新渲染
            this.$nextTick(() => {
                // 通过修改一个不影响显示的属性来触发表格重新渲染
                this.palletsStatsRenderedAt = Date.now();
            });
        }
    }

    initializeData() {
        try {
            this.init();
            this.generateTimeArray();
        } catch (error) {
            // 初始化失败时不做处理
        }
    }

    async getTableData() {
        try {
            await this.fetchData(1);
            this.tableDataLoaded = true;
            return true;
        } catch (error) {
            this.tableDataLoaded = false;
            throw error;
        }
    }

    get filteredTableFieldsObjs() {
        return this.isVendor ? this.tableFieldsObjs.filter(field => field.value !== 'tms_order_stage') : this.tableFieldsObjs;
    }

    /**
     * 格式化Ready Date显示，避免时区问题
     * 直接使用后端日期字符串，不使用new Date()转换
     * @param date 后端返回的日期字符串
     * @returns 格式化后的日期字符串
     */
    formatReadyDate(date: string | undefined): string {
        if (!date) return '';
        
        // 确保日期格式为YYYY-MM-DD
        // 首先检查是否包含时间部分并清除
        let cleanDate = date;
        if (date.includes('T')) {
            cleanDate = date.split('T')[0];
        }
        
        // 如果是字符串格式 (YYYY-MM-DD)，直接解析不考虑时区
        const parts = cleanDate.split('-');
        if (parts.length === 3) {
            const year = parts[0];
            const month = parts[1];
            const day = parts[2].substring(0, 2); // 确保只取日期部分
            return `${month}/${day}/${year}`;
        }
        
        // 如果不是预期的格式，则返回原始字符串
        return cleanDate;
    }

    getReadyDateBlockReason(row: IShipment): string {
        if (!row) {
            return '';
        }

        if (!this.isRowInLocation(row)) {
            return 'Ready Date can only be updated for orders assigned to your location';
        }

        if (!this.isReadyDateStatusEligible(row)) {
            return 'Ready Date can only be updated for orders in Pickup Created status and before dispatch';
        }

        if (!this.hasPalletInfo(row)) {
            return 'Need to input Pallet counts for PO(s)';
        }

        if (this.isPastRequestedDate(row) && !this.canSchedulePastRequestedDateWithoutReadyDate(row)) {
            return 'Requested date has already passed. Please contact UNIS Operations to reschedule';
        }

        return '';
    }

    isRowInLocation(row: IShipment): boolean {
        const shipperId = row?.shipper_id?.toString?.() ?? '';
        return shipperId.length > 0 && this.locationIdStrings.includes(shipperId);
    }

    isReadyDateStatusEligible(row: IShipment): boolean {
        return row.order_stage == 0 && row.order_status == 1;
    }

    canSchedulePastRequestedDateWithoutReadyDate(row: IShipment): boolean {
        return this.isReadyDateStatusEligible(row) && !row.ready_date && this.isPastRequestedDate(row);
    }

    isPastRequestedDate(row: IShipment): boolean {
        const requestedDateKey = this.getRequestedDateKey(row);
        if (!requestedDateKey) {
            return false;
        }

        return this.getTodayDateKey() > requestedDateKey;
    }

    getRequestedDateKey(row: IShipment): string | null {
        if (row.pickup_date) {
            const dateKey = this.toDateKeyFromYmd(row.pickup_date);
            if (dateKey) {
                return dateKey;
            }
        }

        if (row.pickup_date_2) {
            const dateKey = this.toDateKeyFromMdy(row.pickup_date_2);
            if (dateKey) {
                return dateKey;
            }
        }

        return null;
    }

    toDateKeyFromYmd(value: string): string | null {
        const cleanValue = value.split('T')[0].split(' ')[0];
        const parts = cleanValue.split('-');
        if (parts.length !== 3) {
            return null;
        }

        const [year, month, day] = parts;
        return this.normalizeDateKey(year, month, day);
    }

    toDateKeyFromMdy(value: string): string | null {
        const cleanValue = value.split(' ')[0];
        const parts = cleanValue.split('/');
        if (parts.length !== 3) {
            return null;
        }

        const [month, day, year] = parts;
        return this.normalizeDateKey(year, month, day);
    }

    normalizeDateKey(year: string, month: string, day: string): string | null {
        const yearNum = Number(year);
        const monthNum = Number(month);
        const dayNum = Number(day);

        if (!Number.isInteger(yearNum) || !Number.isInteger(monthNum) || !Number.isInteger(dayNum)) {
            return null;
        }

        if (monthNum < 1 || monthNum > 12 || dayNum < 1 || dayNum > 31) {
            return null;
        }

        const yearStr = yearNum.toString().padStart(4, '0');
        const monthStr = monthNum.toString().padStart(2, '0');
        const dayStr = dayNum.toString().padStart(2, '0');
        return `${yearStr}-${monthStr}-${dayStr}`;
    }

    getTodayDateKey(): string {
        const today = new Date();
        const year = today.getFullYear().toString();
        const month = (today.getMonth() + 1).toString().padStart(2, '0');
        const day = today.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    hasPalletInfo(row: IShipment): boolean {
        if (row.order_adjusted && Array.isArray(row.order_adjusted)) {
            const nonEmptyLines = row.order_adjusted.filter(
                (line: IAdjustedOrderLineDto) => !isEmptyAdjustedOrderLine(line)
            );
            if (nonEmptyLines.length > 0) {
                return true;
            }
        }

        if (row.palletsStats) {
            return row.palletsStats.stackable > 0 || row.palletsStats.nonstackable > 0;
        }

        return false;
    }

    /**
     * 判断Ready date是否可以编辑
     * @param item 项目数据
     * @returns 如果Ready date可以编辑返回true，否则返回false
     */
    isReadyDateEditable(item: any): boolean {
        if (!item) {
            return false;
        }

        return this.getReadyDateBlockReason(item) === '';
    }

    isShipmentDetailsEditable(item: any): boolean {
        return !!item && !!item.editable;
    }

    /**
     * 验证并更新项目
     */
    validateAndUpdateItem() {
        this.formValidated = true;
        // 判断Ready date是否可编辑
        const isReadyDateEditable = this.isReadyDateEditable(this.item);
        
        // 只在Ready date可编辑时验证Pickup Times相关字段
        if (isReadyDateEditable) {
            // 验证必填字段是否已填写
            if (!this.item.ready_date) {
                this.scrollToElement(this.$refs.readyDateInput);
                return;
            }
            
            if (!this.item.pickup_ready) {
                this.scrollToElement(this.$refs.readyTimeInput);
                return;
            }
            
            if (!this.item.pickup_close) {
                this.scrollToElement(this.$refs.closeTimeInput);
                return;
            }
            
            // 检查是否修改了Ready date, Ready time或Close time
            this.hasChangedReadyDate = (this.previousReadyDate || '') !== (this.item.ready_date || '');
            this.hasChangedReadyTime = (this.previousReadyTime || '') !== (this.item.pickup_ready || '');
            this.hasChangedCloseTime = (this.previousCloseTime || '') !== (this.item.pickup_close || '');

            // 新的验证逻辑: 只在以下情况下reason必填:
            // 1. 当ready date被修改 且
            // 2. 新的ready date比之前的ready date更晚 且
            // 3. 之前已经设置过ready date (previousReadyDate不为null)
            let isReasonRequired = false;
            
            if (this.hasChangedReadyDate && this.previousReadyDate) {
                // 判断新日期是否比旧日期更晚
                const oldDate = new Date(this.previousReadyDate);
                const newDate = new Date(this.item.ready_date);
                
                if (newDate > oldDate) {
                    isReasonRequired = true;
                }
            }

            // 只有在需要填写reason时才验证
            if (isReasonRequired && !this.messageForYou.reason) {
                this.scrollToElement(this.$refs.reasonInput);
                this.$message.error('Reason is required when updating the ready date to a future date');
                return;
            }

            // 如果reason是Other，则Description必填
            if (this.messageForYou.reason === 'Other' && !this.messageForYou.message) {
                // 假设Description文本框的ref名为descriptionInput
                if (this.$refs.descriptionInput) {
                    this.scrollToElement(this.$refs.descriptionInput);
                }
                this.$message.error('Description is required when reason is Other');
                return;
            }
        }

        // 验证托盘数量
        let hasPalletError = false;
        if (this.item.order_adjusted && this.item.order_adjusted.length > 0) {
            for (let i = 0; i < this.item.order_adjusted.length; i++) {
                const row = this.item.order_adjusted[i];
                if (row.pallet <= 0) {
                    const inputRef = this.$refs[`palletInput-${i}`];
                    // 确保引用存在并且是数组
                    if (inputRef && Array.isArray(inputRef) && inputRef.length > 0) {
                        this.scrollToElement(inputRef[0]);
                        hasPalletError = true;
                        break;
                    }
                }
            }
            if (hasPalletError) {
                return;
            }
        }
        
        // 如果验证通过，更新项目
        this.updateItem();
    }

    /**
     * 滚动到指定元素
     */
    scrollToElement(element: any) {
        if (element && element.$el) {
            // 获取对话框的滚动容器
            const dialogBody = document.querySelector('.shipment-edit-dialog .el-dialog__body');
            if (dialogBody) {
                // 计算元素相对于滚动容器的位置
                const elementRect = element.$el.getBoundingClientRect();
                const containerRect = dialogBody.getBoundingClientRect();
                
                // 计算需要滚动的距离
                const scrollTop = elementRect.top - containerRect.top + dialogBody.scrollTop - 20;
                
                // 平滑滚动到元素位置
                dialogBody.scrollTo({
                    top: scrollTop,
                    behavior: 'smooth'
                });
                
                // 聚焦到元素
                setTimeout(() => {
                    element.focus();
                }, 300);
            }
        }
    }

    /**
     * 获取次日提货截止时间
     */
    async fetchCutoffTime() {
        try {
            // 调用真实接口
            const res = await tmsServiceBackend.get('/cpv2/orders/cutoff-time');
            if (res.status === 200 && res.data.status === 1) {
                this.cutoffTime = res.data.data.cutoff_time || '15:30';
                this.cutoffTimezone = res.data.data.timezone || 'America/Chicago';
                // 格式化显示的截止时间（如"15:30 | 3:30 PM CST"）
                const [hour, minute] = this.cutoffTime.split(':');
                const time24h = `${hour}:${minute}`;
                const hour12 = (parseInt(hour) % 12) || 12;
                const ampm = parseInt(hour) >= 12 ? 'PM' : 'AM';
                const time12h = `${hour12}:${minute} ${ampm}`;
                this.cutoffDialogTime = `${time24h} | ${time12h} ${this.cutoffTimezone === 'America/Chicago' ? 'CST' : this.cutoffTimezone}`;
            } else {
                throw new Error('接口返回异常');
            }
        } catch (error) {
            console.error('获取次日提货截止时间失败', error);
            // 使用默认值
            this.cutoffTime = '15:30';
            this.cutoffTimezone = 'America/Chicago';
            this.cutoffDialogTime = '15:30 | 3:30 PM CST';
        }
    }

    /**
     * Ready date 变更事件处理
     * @param newDate 用户选择的新日期
     */
    onReadyDateChange(newDate: string) {
        if (!newDate) return;
       
        // 获取当前CST时间
        let now = dayjs().tz(this.cutoffTimezone);
        
        // 解析cutoff time
        const [cutoffHour, cutoffMinute] = this.cutoffTime.split(':');
        
        // 当天的cutoff time
        const cutoffTimeToday = now.hour(Number(cutoffHour)).minute(Number(cutoffMinute)).second(0);
        
        // 今天和明天的日期（0时0分0秒）
        const today = now.startOf('day');
        const nextDay = today.add(1, 'day');
        
        // 判断条件：
        // 1. 当前时间已过cutoff time
        // 2. 用户选择的日期是"次日"
        const isPastCutoff = now.isAfter(cutoffTimeToday);
        let isSame = dayjs(newDate).format('YYYY-MM-DD') === nextDay.format('YYYY-MM-DD');
        if (
            isPastCutoff &&
            isSame
        ) {
            // 临时保存用户选择的日期，以便Yes按钮使用
            this.selectedReadyDate = newDate;
            
            // 建议的顺延日期（次日+1天）
            this.cutoffDialogDate = nextDay.add(1, 'day').format('YYYY-MM-DD');
            
            // 只用cutoffDialogVisible控制弹窗显示
            this.cutoffDialogVisible = true;
            
            // 这里不修改item.ready_date，等待弹窗结果
            return false;
        }
        
        return true;
    }

    /**
     * 截止时间提示弹窗 - 是按钮
     * 将Ready date顺延一天
     */
    onCutoffDialogYes() {
        if (this.cutoffDialogDate) {
            // 更新ready_date为顺延后的日期
            if (this.item) {
                this.$set(this.item, 'ready_date', this.cutoffDialogDate);
            }
        }
        
        // 关闭弹窗
        this.cutoffDialogVisible = false;
    }

    /**
     * 截止时间提示弹窗 - 取消按钮
     */
    onCutoffDialogCancel() {
        // 如果用户取消修改，恢复原始日期
        if (this.originalReadyDate && this.item) {
            this.$set(this.item, 'ready_date', this.originalReadyDate);
            
            // 确保el-date-picker显示正确的值
            this.$nextTick(() => {
                // 强制触发UI更新
                this.itemEditDialogKey = Date.now();
            });
        }
        
        // 关闭弹窗
        this.cutoffDialogVisible = false;
    }

    /** 
     * 计算属性：判断修改的ready date是否比原来的日期更晚
     */
    get isReadyDateDelayed(): boolean {
        if (!this.hasChangedReadyDate || !this.previousReadyDate || !this.item?.ready_date) {
            return false;
        }
        
        const oldDate = new Date(this.previousReadyDate);
        const newDate = new Date(this.item.ready_date);
        
        return newDate > oldDate;
    }
}

declare module 'vue/types/vue' {
    interface Vue {
        $message: typeof Message;
    }
}

export default C;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/shipments-4-shippers/components/shipments/index.ts